export abstract class CountriesException extends Error {

}
